import {AssistantEvenCompactModel} from "..";
import {ListModel} from "../common";

import {PhoneBookSchemaFormData} from "@/utils/contacts/phoneBook/phoneBookSchema";

export enum PhoneBookTypeModel {
  INTERNAL = "internal",
  ROUTE_TO_YOUR_API = "routeToYourAPI",
}

export interface PhoneBookAgentModel {
  id: string;
  name: string;
  avatar: string;
}

export interface PhoneBookRecordModel {
  id: string;
  name: string;
  workspaceId: string;
  entryCount: number;
  type?: PhoneBookTypeModel;
  agents?: AssistantEvenCompactModel[];
  // This will be used when the connection type ROUTE_TO_YOUR_API will be implemented in Backend
  apiUrl?: string;
  authKey?: string;
  authValue?: string;
  transferCondition?: string;
  response?: string;
}

export interface PhoneBookEntryRecordModel {
  phoneBookEntryId: string;
  phoneNumber: string;
  transferCondition: string;
  phoneBookId: string;
}

export type PhoneBookListModel = ListModel<PhoneBookRecordModel>;
export type PhoneBookEntryListModel = ListModel<PhoneBookEntryRecordModel>;

export interface PhoneBookCreateModel extends PhoneBookSchemaFormData {
  workspaceId: string;
}
export type PhoneBookUpdateModel = PhoneBookSchemaFormData;
